import gql from 'graphql-tag';

export const all = gql`{
    commodities {
        id
        name
        riskFactor
        isArchived
        commodityGroup {
            id
            name
        }
    }
}`;


export const get = gql`query getCommodity($id: ID!) {
    commodity(id: $id){
        id
        name
        riskFactor
        isArchived
        commodityGroup {
            id
            name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/commodity.js